import BarChartD3 from './BarChartD3';
import ScatterGraphD3 from './ScatterGraphD3';

export const charts = {
  BarChartD3,
  ScatterGraphD3,
};

export default charts;
